
<div :class="['card-item-info', { profile }]">
  <div class="card-set">{{ card.year }} {{ card.set }}</div>

  <div class="card-name">
    <span>{{ card.player }}</span>

    <span v-if="card.number"> #{{ card.number }}</span>
  </div>

  <card-item-chips
    :card="card"
    :profile="profile"
    :is-public="isPublic"
  >
    <slot />
  </card-item-chips>
</div>
